import { hiresPerMonth, markupRateFor } from '../lib/calc';
/**
 * Answer-signal → solution-block library. Each block frames a specific Stanor
 * capability against the specific problem the user's answers revealed.
 * {savings}/{annual}/{roi} tokens are replaced at render with their real numbers.
 */
export const SOLUTION_BLOCKS = {
    roi_hero: {
        id: 'roi_hero',
        eyebrow: 'YOUR NUMBER',
        title: 'Put {savings} a year back in your pocket',
        body: 'You\'re paying {annual}/year in agency markup. Stanor replaces that workflow for a flat {stanorYear}/year — putting {savings}/year back in your pocket, starting on your very first hire.',
        weight: 100,
    },
    lean_hero: {
        id: 'lean_hero',
        eyebrow: 'YOUR NUMBER',
        title: "You're already running lean",
        body: 'At your current volume your agency markup ({annual}/year) is lower than Stanor\'s flat {stanorYear}/year — so on price alone you\'re not overpaying today. The moment you scale your hiring, Stanor becomes the cheaper way to staff.',
        weight: 100,
    },
    no_markup: {
        id: 'no_markup',
        eyebrow: 'HIRE DIRECT',
        title: 'No middleman. No per-hour markup.',
        body: 'Stanor lets you hire directly from your own job posts at a flat monthly price — so you stop paying a premium on every hour every worker clocks.',
        weight: 90,
    },
    bulk_scoring: {
        id: 'bulk_scoring',
        eyebrow: 'STANOR SCORES',
        title: 'Rank 100 applicants in minutes — not days',
        body: 'At your hiring volume, manual screening is the bottleneck. Stanor\'s AI scores and ranks every applicant 0–10 with transparent reasoning, so you only ever look at the top of the stack.',
        weight: 80,
    },
    temp_to_direct: {
        id: 'temp_to_direct',
        eyebrow: 'CONVERT THE SPEND',
        title: 'Turn full-time temp spend into permanent direct hires',
        body: 'Your workers are clocking full-time hours through a temp agency — the most expensive way to staff a permanent role. Stanor helps you source and hire them directly instead.',
        weight: 70,
    },
    cost_visibility: {
        id: 'cost_visibility',
        eyebrow: 'FULL TRANSPARENCY',
        title: 'Always know exactly what a hire costs you',
        body: 'Your agency never told you their markup. With Stanor there\'s nothing hidden — one flat monthly price, every candidate and cost visible in your dashboard.',
        weight: 60,
    },
    sms_antighosting: {
        id: 'sms_antighosting',
        eyebrow: 'STANOR QUALIFIES & SCHEDULES',
        title: 'Text-screen applicants and end no-shows — something agencies don\'t do',
        body: 'Stanor automatically texts applicants to verify availability and commute, books interviews, and sends anti-ghosting reminders that confirm they\'ll show — the part agencies leave to you.',
        weight: 50,
    },
};
/**
 * Pick the ordered set of solution blocks for a given set of answers + results.
 * The hero block is comparison-true (roi_hero when Stanor wins, lean_hero when it
 * doesn't); sms_antighosting always appears; the rest are answer-driven.
 */
export function selectSolutionBlocks(a, r) {
    const ids = new Set([r.stanorWins ? 'roi_hero' : 'lean_hero', 'sms_antighosting']);
    if (markupRateFor(a.markup) >= 0.45)
        ids.add('no_markup');
    if (a.markup === 'C')
        ids.add('cost_visibility');
    if (hiresPerMonth(a.workers) >= 3)
        ids.add('bulk_scoring');
    if (a.hrsPerWeek >= 35)
        ids.add('temp_to_direct');
    // Ensure at least 3 blocks: backfill with no_markup, then bulk_scoring.
    if (ids.size < 3)
        ids.add('no_markup');
    if (ids.size < 3)
        ids.add('bulk_scoring');
    return Array.from(ids)
        .map((id) => SOLUTION_BLOCKS[id])
        .sort((x, y) => y.weight - x.weight);
}
